// extracted by mini-css-extract-plugin
export var appDownloadScreen = "DesktopAppDownload-module--appDownloadScreen--25ca9";
export var close = "DesktopAppDownload-module--close--f5514";
export var desktop = "DesktopAppDownload-module--desktop--7eaaf";
export var downloadLinks = "DesktopAppDownload-module--downloadLinks--ebac9";
export var identifier = "DesktopAppDownload-module--identifier--62099";
export var mobile = "DesktopAppDownload-module--mobile--e17db";
export var section = "DesktopAppDownload-module--section--174ec";
export var title = "DesktopAppDownload-module--title--55622";